export default __webpack_public_path__ + "static/media/surgical_sterilization_disabled.e19e6ea2.svg";